/**
 * @file ProductKindDeleteDialog.tsx
 * @description Подтверждение удаления вида товара (phase19.22, W22).
 *
 * Удалить можно только вид без ссылок; используемый сервер не удалит (409
 * `product_kind_in_use`) — тогда страница предлагает архив. Текст честно
 * говорит об этом заранее, чтобы удаление не было сюрпризом.
 */

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../ui/alert-dialog";
import { Button } from "../../ui/button";
import type { ProductKind } from "../../../lib/api-product-kinds";

interface Props {
  kind: ProductKind | null;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ProductKindDeleteDialog({ kind, busy, onCancel, onConfirm }: Props) {
  return (
    <AlertDialog open={kind !== null} onOpenChange={(o) => (!o && !busy ? onCancel() : null)}>
      <AlertDialogContent fullScreen className="max-w-md gap-3">
        <AlertDialogHeader>
          <AlertDialogTitle>Удалить вид «{kind?.name}»?</AlertDialogTitle>
          <AlertDialogDescription>
            Удалить можно только вид, который не задан ни одной категории и ни одному
            товару. Используемый вид можно убрать в архив — у товаров он продолжит
            действовать, но новым назначаться не будет.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" className="min-h-12" onClick={onCancel} disabled={busy}>
            Не сейчас
          </Button>
          <Button variant="destructive" className="min-h-12" onClick={onConfirm} disabled={busy}>
            Удалить
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
